/* unplugin-vue-components disabled */import { render } from "./audit-api.vue?vue&type=template&id=d730e67a&scoped=true"
import script from "./audit-api.vue?vue&type=script&setup=true&lang=js"
export * from "./audit-api.vue?vue&type=script&setup=true&lang=js"

import "./audit-api.vue?vue&type=style&index=0&id=d730e67a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d730e67a"],['__file',"src/pages/settings/superuser/audit/audit-api.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d730e67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d730e67a', __exports__)) {
    api.reload('d730e67a', __exports__)
  }
  
  module.hot.accept("./audit-api.vue?vue&type=template&id=d730e67a&scoped=true", () => {
    api.rerender('d730e67a', render)
  })

}


export default __exports__